import styled from "styled-components/macro";

// import theme helpers
import { getBreakpoint, getColor } from "../../util/theme";

const NavMobileIcon = styled.div`
  height: 20px;
  width: 40px;

  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 999;

  margin: 0 15px 0 0;

  transform: rotate(0deg);

  transition: all 0.25s linear;

  @media (min-width: ${getBreakpoint("lg")}) {
    display: none;
  }

  span {
    display: block;

    position: absolute;
    left: 0;

    height: 3px;
    width: 100%;

    background-color: ${getColor("white")};

    border-radius: 3px;

    opacity: 1;

    transform: rotate(0deg);

    transition: all 0.25s linear;

    &:first-child {
      top: ${(props) => (props.menuOpen ? "10px" : "0px")};

      transform: ${(props) => (props.menuOpen ? "rotate(135deg)" : null)};
    }

    &:nth-child(2) {
      top: 10px;
      left: ${(props) => (props.menuOpen ? "-60px" : null)};

      opacity: ${(props) => (props.menuOpen ? 0 : 1)};
    }

    &:nth-child(3) {
      top: ${(props) => (props.menuOpen ? "10px" : "20px")};

      transform: ${(props) => (props.menuOpen ? "rotate(-135deg)" : null)};
    }
  }
`;

export default NavMobileIcon;
